/**
 * Chailease.SystemManagement.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface UserProfileMasterViewModel { 
    /**
     * 員工編號
     */
    userNo?: string;
    /**
     * 員工姓名
     */
    userName?: string;
    /**
     * 員工中文姓名
     */
    userChineseName?: string;
    /**
     * 員工電話
     */
    telephone?: string;
    /**
     * 員工分機
     */
    telephoneExtension?: string;
    /**
     * 員工手機
     */
    cellPhone?: string;
    /**
     * 員工E-Mail
     */
    email?: string;
    /**
     * 員工性別
     */
    gender?: boolean;
    /**
     * 員工狀態(1=在職 0=離職)
     */
    enable?: boolean;
    /**
     * 發薪公司
     */
    salaryCompanyId?: number;
    /**
     * 到職日
     */
    hireDate?: Date;
    /**
     * 離職日
     */
    quitDate?: Date;
    /**
     * 試用期滿日
     */
    trialDate?: Date;
}